import getJWTs from './get-jwts';
import getFinancoAccessTokens from './get-financo-access-tokens';

function refreshSimulators() {
    const simulatorEls = [...document.querySelectorAll('.financo-simulator:not(.financo-simulator--loading):not(.financo-simulator--fetched)')];

    if(simulatorEls.length) {
        let simulatorsData = {};

        simulatorEls.forEach((el) => {
            const data = {
                id: el.hasAttribute('id') ? el.getAttribute('id') : null,
                price: el.hasAttribute('data-price') ? el.getAttribute('data-price') : null,
                registerDate: el.hasAttribute('data-register-date') ? el.getAttribute('data-register-date') : null,
                name: el.hasAttribute('data-name') ? el.getAttribute('data-name') : null,
                brand: el.hasAttribute('data-brand') ? el.getAttribute('data-brand') : null,
                has_vat: el.hasAttribute('data-has-vat') ? el.getAttribute('data-has-vat') : null
            };

            el.classList.add('financo-simulator--loading');
            
            if(data.id !== null && data.price !== null && data.registerDate !== null && data.name !== null && data.brand !== null && data.has_vat !== null) {
                simulatorsData[data.id] = data;
            }
        });

        if(Object.keys(simulatorsData).length) {
            getJWTs(fin.jwt_tokens_nonce, fin.ajax_url, simulatorsData)
                // Appel à l'API Financo pour récupérer un token
                .then((JWT_tokens) => {
                    console.log('JWT_tokens', JWT_tokens);
                    return getFinancoAccessTokens(JWT_tokens, fin.ajax_url);
                })
                .then((accessTokens) => {
                    console.log('accessTokens', accessTokens);
                    if(Object.keys(accessTokens).length) {
                        Object.keys(accessTokens).forEach((key) => {
                            const simulatorPlaceholder = document.querySelector(`#${key}`);
                            
                            if(simulatorPlaceholder && accessTokens[key].financo_token) {
                                // Création de l'iframe dans le div avec data-fws-id="financowebsimu"
                                const iframe = document.createElement('iframe');
                                iframe.setAttribute('width', '100%');
                                iframe.setAttribute('height', '500px');
                                iframe.setAttribute('src', 'https://lecredit.financo.fr/finwebsimu');

                                // Envoi du token
                                iframe.onload = function () {
                                    // setTimeOut bugfix firefox
                                    setTimeout(() => {
                                        iframe.contentWindow.postMessage(
                                            {
                                                sender: 'finwebsimu-adherent',
                                                token: accessTokens[key].financo_token
                                            }, 
                                            '*'
                                        );
                                    }, 200);
                                };
                                
                                // On crée un écouteur de message
                                window.addEventListener('message', (e) => {
                                    // Afin de cibler le message
                                    if (
                                        e.data.message === 'financowebsimu' &&
                                        e.data.token === accessTokens[key].financo_token
                                    ) {
                                        iframe.height = e.data.height;
                                    }
                                });

                                simulatorPlaceholder.classList.remove('financo-simulator--loading');
                                simulatorPlaceholder.classList.add('financo-simulator--fetched');
                                simulatorPlaceholder.appendChild(iframe);
                            }
                        });
                    }
                })
                .catch((err) => console.warn('Erreur lors de la création du simulateur Financo', err));
        }
    }
}

refreshSimulators();
document.addEventListener('simulator:refresh', refreshSimulators);